/**
 * @fileoverview O contato da Sttelar no WhatsApp (+55 11 92622-8406), com a
 * mensagem pronta: o cadastro fechado, a contratação ainda indisponível e o
 * Faturamento das Empresas de antes dos planos.
 */

export const sttelarWhatsAppUrl = (message) => `https://wa.me/5511926228406?text=${encodeURIComponent(message)}`;
